import React, { PureComponent } from 'react';
import { BaseInputProps } from '../types';
import classNames from 'classnames';
import { isEmpty, isNullLike } from '../utils';
import { Num } from './Num';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import Big from 'big.js';
import { Input } from 'antd';

export interface TextValueArrayInfo {
  key?: string;
  value?: number;
}

export interface TextValueArrayProps extends BaseInputProps {
  value?: TextValueArrayInfo[];
  isPercentage?: boolean;
  onChange?: (val?: TextValueArrayInfo[]) => void;
}

export class TextValueList extends PureComponent<TextValueArrayProps> {
  value: TextValueArrayInfo[] = [];

  isEmptyItem = (item: TextValueArrayInfo) => {
    return isEmpty(item.key) && isNullLike(item.value);
  };

  onChange = (i: number, val: any, key?: keyof TextValueArrayInfo) => {
    const value = [...this.value];
    if (!value[i]) value[i] = { key: '' };
    if (key) value[i][key] = val as never;
    else value[i] = { ...value[i], ...val };

    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0]) ? [] : value.filter((it) => !!it.key),
    );
  };

  onAdd = (i: number) => {
    const value = [...this.value];
    value.splice(i + 1, 0, { key: '' });
    this.props.onChange?.(value);
    this.props.onBlur?.();
  };

  onDel = (i: number) => {
    const value = [...this.value];
    value.splice(i, 1);
    this.props.onChange?.(value.length === 1 && this.isEmptyItem(value[0]) ? [] : value);
    this.props.onBlur?.();
  };

  render() {
    this.value = this.props.value || [];
    // if (!this.value.length && !this.props.readonly) this.value.push({ key: '' });
    return (
      <div
        className={classNames(
          'param-expiries-limit',
          { readonly: this.props.readonly },
          this.props.className,
        )}
        style={this.props.style}
      >
        {this.props.readonly ? (
          this.props.value?.length ? (
            this.value
              .filter((it) => it.key)
              .map((it, i) => (
                <>
                  <span className="param-expiries-limit-val" key={i}>
                    {it.key}
                    <span className="param-expiries-limit-val-sep">/</span>
                    {!isNullLike(it.value)
                      ? this.props.isPercentage
                        ? `${+Big(Number(it.value)).times(100)}%`
                        : it.value
                      : '-'}
                  </span>
                  <br />
                </>
              ))
          ) : (
            '-'
          )
        ) : (
          <div className="grid grid-cols-8 gap-4 w-full p-2">
            <div className="font-medium text-gray-700 col-span-3 rounded-md">Text</div>
            <div className="font-medium text-gray-700 col-span-2 rounded-md">Value</div>
            {
              this.value.length > 0 ? <>
                <div className='col-span-1'/>
                <div className='col-span-2'/>
              </> : <>
                <div className='col-span-2 flex space-x-2'>
                  <PlusOutlined
                    onClick={this.onAdd.bind(null, 0)}
                  />
                </div>
              </>
            }
            {this.value.map((it, i) => (
              <React.Fragment key={i}>
                <Input
                  type="text"
                  placeholder={this.props.placeholder || 'Text'}
                  value={it.key}
                  onChange={(e) =>
                    this.onChange(
                      i,
                      e.target.value.trim() === '' ? undefined : e.target.value,
                      'key',
                    )
                  }
                  onBlur={this.props.onBlur}
                  autoComplete="off"
                  className='col-span-3'
                />
                <Num
                  value={it.value}
                  onChange={(val) => this.onChange(i, { value: val })}
                  onBlur={this.props.onBlur}
                  isPercentage={this.props.isPercentage}
                  className='col-span-2'
                />
                <div className='col-span-1'/>
                <div className='col-span-2 flex space-x-2'>
                  <PlusOutlined onClick={this.onAdd.bind(null, i)} />
                  <DeleteOutlined
                    onClick={this.onDel.bind(null, i)}
                  />
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    );
  }
}
